import { allRoutes } from "./allRoutes";
import { createLinks } from "./createLinks";

export const links = createLinks(allRoutes);
